<template lang="html">
    <div class="page" id="proPlayerSkills" v-if="player">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/players.png" />
        </header>

        <div class="scroller2 dark">
            <header>
                <h2>Practice drills</h2>
                <ul class="links">
                    <li>
                        <router-link
                            class="cancel"
                            :to="{ name: 'proPlayer', params: { id: $route.params.id } }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <div class="band">{{ player.first_name }} {{ player.last_name }}</div>

            <empty-placeholder class="mt30" v-if="skills.length == 0">
                TIP: Test your players with simple skill tests to help encourage better practice. To
                get started tap the button below.
            </empty-placeholder>

            <div class="proSwitch" :class="{ active: player.skills_enabled }">
                <button
                    type="button"
                    name="button"
                    @click="toggleSkills"
                    style="border-top-left-radius: 12px; border-bottom-left-radius: 12px"
                >
                    {{ player.skills_enabled ? "Practice area enabled" : "Practice area disabled" }}
                </button>
                <button
                    type="button"
                    name="button"
                    @click="toggleSkills"
                    style="border-top-right-radius: 12px; border-bottom-right-radius: 12px"
                >
                    {{ player.skills_enabled ? "Disable" : "Enable" }}
                </button>
            </div>

            <empty-placeholder class="mt30 warning" v-if="!player.skills_enabled">
                IMPORTANT: This area is currently hidden from this Players account. To share and
                edit this feature use the enable button above.
            </empty-placeholder>

            <button
                @click.prevent="editOpen = !editOpen"
                v-if="player.skills_enabled"
                class="button left addSkill"
                type="button"
            >
                Add practice drill
                <plus-icon class="icon" />
            </button>

            <!-- add skill here -->
            <add-edit-skill
                :editOpen="editOpen"
                @addEditSkillClosed="closeEdit"
                @skillAdded="addSkill"
            />

            <div v-if="player.skills_enabled">
                <skills-list-item
                    type="pro"
                    @skillRemoved="removeSkill"
                    v-for="skill in skills"
                    :key="skill.id"
                    :skill="skill"
                    @skillUpdated="updateSkill"
                />
            </div>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import FadeImage from "@/components/App/fade-image";
import AddEditSkill from "@/views/Pro/Players/Player/partials/add-edit-skill";
import { PlusIcon, XIcon } from "vue-feather-icons";
import SkillsListItem from "@/components/Player/Skills/Skills-list-item";
export default {
    name: "skills",
    components: { EmptyPlaceholder, FadeImage, XIcon, PlusIcon, SkillsListItem, AddEditSkill },
    mounted() {
        if (!this.$store.state.activePlayer) {
            this.$store.dispatch("getPlayer", this.$route.params.id);
        }
        this.getPlayerSkills();
    },
    computed: {
        player() {
            return this.$store.state.activePlayer;
        },
    },
    data() {
        return {
            editOpen: false,
            skills: [],
        };
    },
    methods: {
        closeEdit() {
            this.editOpen = false;
        },
        addSkill(skill) {
            this.skills.unshift(skill);
        },
        removeSkill($skill) {
            var index = this.skills.findIndex((skill) => {
                return skill.id == $skill.id;
            });
            this.skills.splice(index, 1);
        },
        updateSkill($skill) {
            var index = this.skills.findIndex((skill) => {
                return skill.id == $skill.id;
            });
            this.skills.splice(index, 1, $skill);
        },
        toggleSkills() {
            this.player.skills_enabled = !this.player.skills_enabled;
            window.axios.put("/user/" + this.$route.params.id, this.player);
        },
        getPlayerSkills() {
            window.axios.get("player/" + this.$route.params.id + "/skills").then((response) => {
                this.skills = response.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#proPlayerSkills {
    .links li a {
        color: white;
    }
    .band {
        background: $darkGrey_1;
        padding: 18px;
        color: white;
        border-radius: $radius;
        margin-bottom: 10px;
    }
    .addSkill {
        background: $darkGrey_1;
        margin-bottom: 30px;
    }

    .proSwitch {
        margin-bottom: 10px;
        border-radius: $radius;
        overflow: hidden;
        button {
            appearance: none;
            background: none;
            border: 0px;
            padding: 20px;
            padding-top: 17px;
            padding-bottom: 17px;
            background: red;
            font-size: 1rem;
            color: white;
            background: $red;
            width: calc(100% - 100px);
            text-align: left;
            position: relative;
            font-family: canada-type-gibson, sans-serif;
            &:focus {
                outline: 0;
            }
            &:first-of-type {
                z-index: 1;
                &:after {
                    content: "";
                    position: absolute;
                    width: 10px;
                    height: 100%;
                    background: $red;
                    top: 0px;
                    right: -10px;
                    border-top-right-radius: $radius;
                    border-bottom-right-radius: $radius;
                }
            }
            &:last-of-type {
                width: 100px;
                padding-left: 29px;
                background: $green_0;
            }
        }

        &.active {
            button {
                background: $green_0;
                &:first-of-type {
                    &:after {
                        background: $green_0;
                    }
                }
                &:last-of-type {
                    width: 100px;
                    background: $red;
                }
            }
        }
    }
}
</style>
